"use client";
import Script from "next/script";

export function StoryblokBridgeScript({
  enabled
}: {
  enabled: boolean;
}) {
  if (!enabled) {
    return null;
  }
  return (
    <Script
      id="storyblok-bridge"
      src="https://app.storyblok.com/f/storyblok-v2-latest.js"
      strategy="afterInteractive"
    />
  );
}
